import { mutatorAction, mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { toggleAgendaPane } from '../actions/toggleAgendaPane';

export const setIsAgendaPaneShown = mutatorAction(
    'isAgendaPaneShown',
    (isAgendaPaneShown: boolean) => {
        getStore().isAgendaPaneShown = isAgendaPaneShown;
    }
);

mutator(toggleAgendaPane, () => {
    const newAgendaPaneState = !getStore().isAgendaPaneShown;
    getStore().isAgendaPaneShown = newAgendaPaneState;
});
